import { appendQueryString, NavigationConfiguration, ScreenBase, HashNavigationAdapter } from "@frui.ts/screens";

/**
 * Monkey patch of UrlNavigationAdapter
 * https://github.com/eManPrague/frui.ts/blob/develop/packages/screens/src/navigation/hashNavigationAdapter.ts#L53
 *
 * Fix push to history on widget init
 */
/* eslint-disable @typescript-eslint/ban-ts-comment */
export function monkeyPatchHashNavigationAdapter() {
  // @ts-ignore
  HashNavigationAdapter.prototype.updateUrl = function (screen) {
    // @ts-ignore
    if (this.rootViewModel) {
      const path = screen.getNavigationPath();
      const url = appendQueryString(NavigationConfiguration.hashPrefix + path.path, path.params);

      if (window.location.hash !== url) {
        const shouldReplaceUrl =
          // !!! Only change is commented next line !!!
          // window.location.hash &&
          url.startsWith(window.location.hash) &&
          // @ts-ignore
          (!this.lastActiveScreen || (this.lastActiveScreen as ScreenBase).childReplacesNavigationPath);

        if (shouldReplaceUrl) {
          window.history.replaceState(null, screen.name, url);
        } else {
          window.history.pushState(null, screen.name, url);
        }
      }
    }
    // @ts-ignore
    this.lastActiveScreen = screen;
  };
}

/* eslint-enable @typescript-eslint/ban-ts-comment */
